module.exports = __webpack_public_path__ + "static/basis-grotesque-bold-pro-616dbe0c3aba78138d045d8abf1a2a52.otf";